import { Chip, ChipProps, paletteColors } from '@evaneos/b2b-ui';
import CancelIcon from '@evaneos/b2b-ui/icons/Cancel';

export const TAG_CHIP_COLOR = paletteColors.green[200] ?? '#B4D8E2';

export const TagChip = ({
    label,
    onDelete,
    ...chipProps
}: {
    label: string;
} & Pick<ChipProps, 'onDelete'>) => (
    <Chip
        size="small"
        label={label}
        sx={{
            backgroundColor: TAG_CHIP_COLOR,
            fontWeight: 600,
            borderRadius: '4px',
            lineHeight: '24px',
        }}
        onDelete={onDelete}
        deleteIcon={<CancelIcon />}
        {...chipProps}
    />
);
